// extracted by mini-css-extract-plugin
export default {"search-form":"ww9EZoAkLCndtGDh9X0x","top":"n3anF3w5dP45pICTpBQi","top-label":"fmBc6_KBnd4_1bNZ5PMM","bottom":"oc89XdugrDXtJCQnDrX_"};